<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    :width="width"
    append-to-body
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="90px">
      <el-form-item label="公司名称" prop="companyName">
        <el-input
          v-model="form.companyName"

          placeholder="请输入公司名称"
        />
      </el-form-item>
      <el-form-item label="联系人" prop="contactName">
        <el-input
          v-model="form.contactName"

          placeholder="请输入联系人"
        />
      </el-form-item>
      <el-form-item label="联系电话" prop="contactPhone">
        <el-input
          v-model="form.contactPhone"

          placeholder="请输入联系电话"
        />
      </el-form-item>
      <el-form-item label="联系邮箱" prop="mailBox">
        <el-input
          v-model="form.mailBox"

          placeholder="请输入联系邮箱"
        />
      </el-form-item>
      <el-form-item label="收益分成" prop="taxPoint">
        <el-input
          v-model="form.taxPoint"

          type="number"
          placeholder="请输入收益分成"
        />
      </el-form-item>

      <el-form-item label="主体名称" prop="subjectId">
        <el-select
          v-model="form.subjectId"
          clearable
          filterable

          placeholder="请选择主体名称"
          style="margin-right: 15px; width: 100%"
        >
          <el-option
            v-for="item in statusList"
            :label="item.subjectName"
            :value="item.subjectId"
            :key="item.subjectId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="渠道主体" prop="channelSubject">
        <el-select
          v-model="form.channelSubject"
          placeholder="请选择渠道主体"
          style="width: 100%"
        >
          <el-option
            v-for="item in channelSubjectList"
            :label="item.subjectName"
            :value="item.subjectId"
            :key="item.subjectId"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="营业执照" prop="imageUrl">
        <el-upload
          class="avatar-uploader"
          :action="$baseURL + 'common/upload/image'"
          :headers="header"
          :show-file-list="false"
          :on-success="onSuccess"
          accept="image/*"
        >
          <img
            v-if="form.imageUrl"
            :src="$imgURL + form.imageUrl"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="渠道名称" prop="channelName">
        <el-input
          v-model="form.channelName"

          placeholder="请输入渠道名称"
        />
      </el-form-item>
      <el-form-item label="渠道类型" prop="channelType">
        <el-select
          v-model="form.channelType"
          placeholder="请选择渠道类型"
          style="width: 100%"
        >
          <el-option
            v-for="item in channelTypeList"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="渠道状态" prop="isEnable">
        <el-radio v-model="form.isEnable" :label="1">禁用</el-radio>
        <el-radio v-model="form.isEnable" :label="0">正常</el-radio>
      </el-form-item>
      <el-form-item label="开户行" prop="bank">
        <el-input
          v-model="form.bank"

          placeholder="请输入开户行"
        />
      </el-form-item>
      <el-form-item label="银行账号" prop="bankAccount">
        <el-input
          v-model="form.bankAccount"

          placeholder="请输入银行账号"
        />
      </el-form-item>
      <el-form-item label="开户名" prop="bankName">
        <el-input
          v-model="form.bankName"

          placeholder="请输入开户名"
        />
      </el-form-item>
      <div v-show="!form.channelId">
        <el-form-item label="账号名" prop="accountName">
          <el-input
            v-model="form.accountName"

            placeholder="请输入账号名"
          />
        </el-form-item>
        <el-form-item label="登录账户" prop="account">
          <el-input
            v-model="form.account"

            placeholder="请输入账户"
          />
        </el-form-item>
        <el-form-item label="登录密码" :prop="form.channelId ? '' : 'password'">
          <el-input
            v-model="form.password"

            placeholder="请输入登录密码"
          />
        </el-form-item>
      </div>
      <div v-show="form.channelType === 2">
        <el-form-item label="URI" prop="uri">
          <el-input
            v-model="form.uri"

            placeholder="请输入URI"
          />
        </el-form-item>
        <el-form-item label="宏参数" prop="macroParams">
          <el-input
            v-model="form.macroParams"

            placeholder="请输入宏参数"
          />
        </el-form-item>
        <el-form-item label="密钥" prop="ekey">
          <el-input
            v-model="form.ekey"

            placeholder="请输入密钥"
          />
        </el-form-item>
      </div>
    </el-form>
    <div style="text-align: right">
      <el-button @click="close" >取消</el-button>
      <el-button
        @click="submit"
        type="primary"

        :loading="submitLoading"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { addChannel, updateChannel, getSubjectInfo,getChannelSubjectList } from '@/api/manage/channel/channel'

const form = {
  companyName: undefined,
  contactName: undefined,
  contactPhone: undefined,
  mailBox: undefined,
  taxPoint: undefined,
  imageUrl: undefined,
  channelName: undefined,
  channelId: undefined,
  channelType: 1,
  isEnable: 0,
  account: undefined,
  password: undefined,
  accountName: undefined,
  bank: undefined,
  bankAccount: undefined,
  bankName: undefined,
  subjectId: undefined
}
export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 600
    },
    data: Object
  },
  emits: ['submit'],
  data() {
    return {
      dialogStatus: false,
      submitLoading: false,

      header: {},

      channelTypeList: [
        { label: 'CPM', value: 1 },
        { label: 'CPA', value: 2 },
        { label: '通用', value: 3 }
      ],
      statusList: [],
      form: Object.assign({}, form),
      rules: {
        companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        contactName: [{ required: false, message: '请输入联系人', trigger: 'blur' }],
        contactPhone: [{ required: false, message: '请输入联系电话', trigger: 'blur', pattern: /^1[0-9]{10}$/ }],
        mailBox: [{ required: false, message: '请输入联系邮箱', trigger: 'blur', pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/ }],
        channelName: [{ required: true, message: '请输入渠道名称', trigger: 'blur' }],
        account: [{ required: true, message: '请输入账户', trigger: 'blur' }],
        taxPoint: [{ required: false, message: '请输入收益分成', trigger: 'blur' }],
        password: [{ required: true, message: '请输入登录密码', trigger: 'blur' }],
        accountName: [{ required: true, message: '请输入账户名', trigger: 'blur' }],
        bank: [{ required: false, message: '请输入开户行', trigger: 'blur' }],
        bankAccount: [{ required: false, message: '请输入银行账号', trigger: 'blur' }],
        bankName: [{ required: false, message: '请输入开户名', trigger: 'blur' }],
        imageUrl: [{ required: true }],
        subjectId: [{ required: true, message: '请选择主体名称', trigger: 'blur' }],
        channelSubject: [{ required: true, message: '请选择渠道主体', trigger: 'blur' }]
      },
      channelSubjectList:[]
    }
  },
  created() {
    this.header = {
      Authorization: 'Bearer ' + this.access_token
    }
    this._getSubjectInfo()
    this.getChannelSubjectList()
  },
  computed: {
    ...mapGetters([
      'access_token'
    ]),
    dialogTitle() {
      return (this.title ? this.title : '') + (this.form.channelId ? '编辑' : '新增')
    }
  },
  methods: {
    show(data) {
      this.dialogStatus = true
      if (data) {
        this.form = Object.assign({}, data)
      }
    },
    close() {
      this.dialogStatus = false
      this.reset()
    },
    onSuccess(res) {
      if (res.code === 200) {
        this.form.imageUrl = res.data[0] || ''
      }
    },
    submit() {
      this.statusList.forEach(index=>{
        if (index.subjectName === this.form.subjectId) {
          this.form.subjectId = index.subjectId
        }
      })
      this.$refs.form.validate(valid => {
        if (this.validate() && valid) {
          if (this.form.channelId) {
            this.updateChannel(this.form)
          } else {
            this.addChannel(this.form)
          }
        }
      })
    },
    addChannel(form) {
      this.submitLoading = true
      addChannel(form).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    updateChannel(form) {
      this.submitLoading = true
      updateChannel(form).then(res => {
        if (res.code === 200) {
          this.$message.success('编辑成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    validate() {
      if (!this.form.imageUrl) {
        this.$message.warning('请上传营业执照')
        return
      }
      return true
    },
    reset() {
      this.form = Object.assign({}, form)
      this.$refs.form.resetFields()
    },
    _getSubjectInfo() {
      getSubjectInfo().then(res => {
        this.statusList = res.data
      })
    },
    getChannelSubjectList() {
      getChannelSubjectList().then(res => {
        this.channelSubjectList = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}

::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>
